import React from "react";
import _ from "lodash";
//Utils
import { shortDateTimeFromString } from "../../utils/format";
//Controls
import { Row, Col } from "reactstrap";

const ComplaintComments = ({ comments, fromManager }) => {
  return (
    <>
      {comments &&
        _.orderBy(comments, "createdAt", "asc").map((item) => {
          return (
            <Row
              className={fromManager == item.fromManager ? "text-right" : ""}
            >
              <Col xs="12" className="p-2">
                <small className="d-block font-size-10 text-black-50 px-3">
                  {shortDateTimeFromString(item.createdAt)}
                </small>
                <div className="d-inline-block bg-light rounded-pill font-size-13 p-1 px-3">
                  <div>
                    <small>
                      {item.inProgress && "En trámite - "}
                      {item.closed && "Cerrada - "}
                    </small>
                    <small className="font-weight-bold">
                      {item.fromManager ? "Gestor" : "Denunciante"}
                    </small>
                  </div>

                  <label className="form__checkbox-label">{item.comment}</label>
                </div>
              </Col>
            </Row>
          );
        })}
    </>
  );
};

export default ComplaintComments;
